(() => {
  const key = 'puffora.cartOrigin.v1';
  const restoreKey = 'puffora.cartRestore.v1';
  function safeUrl(value) {
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin || /\/(cart|checkout|checkouts|account)(\/|$)/.test(url.pathname)) return null;
      return url.pathname + url.search + url.hash;
    } catch (_) { return null; }
  }
  function read(name) { try { return JSON.parse(sessionStorage.getItem(name)); } catch (_) { return null; } }
  function save(name, value) { try { sessionStorage.setItem(name, JSON.stringify(value)); } catch (_) {} }
  const current = safeUrl(location.href);
  if (current) {
    const record = () => save(key, { url: current, scroll: window.scrollY, time: Date.now() });
    record();
    window.addEventListener('pagehide', record);
    document.addEventListener('click', record, true);
    const restore = read(restoreKey);
    if (restore && restore.url === current) {
      try { sessionStorage.removeItem(restoreKey); } catch (_) {}
      const scrollBack = () => requestAnimationFrame(() => window.scrollTo(0, Number(restore.scroll) || 0));
      if (document.readyState === 'complete') scrollBack();
      else window.addEventListener('load', scrollBack, { once: true });
    }
  }
  function destination(link) {
    const stored = read(key);
    if (stored && Date.now() - stored.time < 86400000 && safeUrl(stored.url)) return stored;
    const referrer = document.referrer && safeUrl(document.referrer);
    return { url: referrer || safeUrl(link.getAttribute('href')) || '/', scroll: 0 };
  }
  document.querySelectorAll('[data-puffora-cart-back]').forEach(link => { link.href = destination(link).url; });
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-puffora-cart-back]');
    if (!link || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    const target = destination(link);
    save(restoreKey, target);
    location.assign(target.url);
  });
})();
